import React, { useState } from 'react';
import { Form, Button, Alert, Container, Row, Col, Card, InputGroup } from 'react-bootstrap';
import { useAuth } from '../components/autentication-context.component';
import HeaderImage from '../components/header-image.component';
import { login } from '../../services/auth.service';

interface LoginProps {
    onLoginSuccess: () => void;
}

const Login: React.FC<LoginProps> = ({ onLoginSuccess }) => {
    const { setAuthData } = useAuth();
    const [email, setEmail] = useState<string>('');
    const [password, setPassword] = useState<string>('');
    const [showPassword, setShowPassword] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);
    const [loading, setLoading] = useState<boolean>(false);

    const handleLogin = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setLoading(true);
        setError(null);

        try {
            const data = await login(email, password);
            const { token, employeeId, firstName } = data;
            if (token) {
                setAuthData({ token, employeeId, firstName });
                onLoginSuccess();
            } else {
                setError('Invalid email or password');
            }
        } catch (error) {
            setError('Login failed. Please try again later.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Container fluid className="d-flex align-items-center justify-content-center vh-100">
            <Row className="w-100">
                <Col xs={12} sm={10} md={8} lg={6} xl={4} className="mx-auto">
                    <Card className="shadow-lg p-4 login-card">
                        <Card.Header className="text-center">
                            <HeaderImage />
                        </Card.Header>
                        <Card.Body>
                            {error && <Alert variant="danger">{error}</Alert>}
                            <Form onSubmit={handleLogin}>
                                <Form.Group controlId="formBasicEmail">
                                    <Form.Label>Email</Form.Label>
                                    <Form.Control
                                        type="email"
                                        placeholder="Enter your email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        required
                                    />
                                </Form.Group>
                                <Form.Group controlId="formBasicPassword" className="mt-3">
                                    <Form.Label>Password</Form.Label>
                                    <InputGroup>
                                        <Form.Control
                                            type={showPassword ? 'text' : 'password'}
                                            placeholder="Enter your password"
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                            required
                                        />
                                        <Button
                                            variant="outline-secondary"
                                            onClick={() => setShowPassword(!showPassword)}
                                            className="toggle-password"
                                        >
                                            <i className={`bi ${showPassword ? 'bi-eye' : 'bi-eye-slash'}`}></i>
                                        </Button>
                                    </InputGroup>
                                </Form.Group>
                                <Button type="submit" disabled={loading} className="greenButton w-100 mt-4">
                                    {loading ? 'Loading...' : 'LOGIN'}
                                </Button>
                            </Form>
                        </Card.Body>
                        {/* <Card.Footer>
                            <p>
                                Don't have an account?{' '}
                                <Link className="p-0 text-decoration-none greenColour" to="/register">Register here</Link>
                            </p>
                        </Card.Footer> */}
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default Login;